export default __webpack_public_path__ + "static/media/DharmaGothicE_Heavy_R.2d65d70f.otf";